<template>
	<p class="product-tile-tag">
		<slot></slot>
	</p>
</template>

<script lang="ts" setup>

</script>

<style lang="scss">
.product-tile-tag {
  @include text-mobile-detail-text;
  font-weight: 700;
  display: table;
  margin: 0;
  padding: 0 rem-calc(4px);

  &:before {
    display: block;
    width: 100%;
    margin-bottom: rem-calc(4px);
    content: "";
    transform: scaleX(1.1);
    border-top: 4px solid var(--theme-campaign-tile);
    border-radius: 4px;
  }

  &--agreement-price {
    &:before {
      border-color: #E15F5F;
    }
  }

  &--alternative {
    min-width: 46px;
    padding: 6px;
    text-align: center;
    height: fit-content;
    color: var(--default-button-text-color);
    border-radius: 2px;
    background: #E15F5F;

    &:before {
      content: none;
    }
  }

  &--new {
    color: var(--default-button-text-color);
    background: #000000;

    &:before {
      content: none;
    }
  }
}
</style>
